import api from '../services/api';

export default class BaseService {
    constructor(resource) {
        this.resource = resource.endsWith('/') ? resource : `${resource}/`;
    }

    getAll(params) {
        return api.get(this.resource, { params });
    }

    get(id, params) {
        return api.get(`${this.resource}${id}/`, { params });
    }

    create(data) {
        return api.post(this.resource, data);
    }

    update(id, data) {
        return api.put(`${this.resource}${id}/`, data);
    }

    delete(id) {
        return api.delete(`${this.resource}${id}/`);
    }
}
